var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMouth2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "Mouth_2.svg",
    "data-name": "Mouth 2.svg",
    x: 206,
    y: 243,
    width: 88,
    height: 14,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAAAOCAYAAACrQtveAAADhklEQVRYhdzPQQrCUBAD0De21fvf1W6KOBL6PxSP0EDIJJNNqrvdAVW1YPvjEzNf8Ro+yPAvHvhcsrCGBunER2cnfv7CA2/subv77OIHAAD//5TROwpCMRSE4e9aqYWCCBa6/23oNm7pBqx9IJGBE4h2FgOTQ3KY+fMFeJqmRYValxLsXbpXkAdeWdz+/J3an3BRfD+ndHwgRDkHRnzmydHv9DeZxS+xxR4nHHHADhusSunV9/UMI8QRePqO3Ua4vz5MbphxxgXX1toTPgAAAP//vJLBCYAwEAQnb7UHH9ZhoXZhLfYgiIj+hURW9iQVGFhCjpDcze4HOKWkgXpgtAY3nu3OAWzAap3AZfDZTdUpUKORHr0dpnU+S4LTGEDr/wRFNd0NMJHAgBqww5x3BO+q1yn7a2n+HZiBCVhKKfcDAAD//2JBClxDBgaGdAYGBi8GBgZhJA8wIAUcAxr/P1L2+Yckx4jGRjYL2fPIqQjGRreTnICid+CCACiiJRgYGCIZGBg+MTAwvGFkZHwMAAAA//9igHpemYGBYQpU4v8ophifY2BgcGNgYGAFAAAA//+ClXs6DAwMjtDsOwooB5LguoCBgQUAAAD//4JVIIoMDAxiowFLNQAp9hgYGAAAAAD//2KC0sOjrTZ4wBNQS4KBgeE3AAAA//+CtQFBnFcjPVSoBECtq12gZtv/////AAAAAP//YoK2aS9D23BfhoUXSQewio0YgE0dSAyUUB8xMDAsZmBgWAVOsAwMDAAAAAD//8zXwQmAMBAF0Vmw/y6sRHuwgrRgrmHAD4vg3b3kGBL28GazOqrKld4ff34x7U+f4YSH72DwoZrUxRH7hpGLo9dvYDazx9QJkPjas/Oyezuxk/Eee+ACDuAEhgYGWAAAAP//dJdBCoAwDARXvPgSv+H//+LNoxcZyEgIWliaQKHppofMH2gcSfaio60kdq7t0uVj5p1zraaYTxxFPJhcY5D0KDleFWMSMWKsBID4LWcDH6kTgyXRHjuza5Rw0s1jt4EsmjCb61nqoy50v4Sb5AEAAP//wtVV5oZiFiifHa1XxgntafFAm3b8UD6svw8LHFAAgDz9ESmAYP1+WOcEFrAgcVhWg/XvYakRpA/mERCABRS4yw7TQ2rXneaAgYEBAAAA//+iaLAHGiHIXVb0XhgsIEB+H3ktFQYGBgAAAAD//wMAMxxKOHZ/NHAAAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouth2);
export default __webpack_public_path__ + "static/media/Mouth 2.5fef310fcf23f0ffa2ba2ceffdc83757.svg";
export { ForwardRef as ReactComponent };